import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as Sentry from "@sentry/react";
import "./i18n";

// Initialize Sentry for error tracking and performance monitoring
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.2, // Capture 20% of transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
    // Environment
    environment: process.env.NODE_ENV || 'development',
    // Release tracking
    release: process.env.REACT_APP_VERSION || 'flotto-frontend@1.0.0',
  });
  console.log('Sentry error tracking initialized');
} else {
  console.warn('REACT_APP_SENTRY_DSN not configured - Error tracking disabled');
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
